// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"6e5b81d1","78":"3d6a1934","269":"90e6cba9","335":"a82dc590","363":"c9d1285c","371":"2fd60043","508":"a69a0bcd","526":"5dba7652","582":"7772b38c","610":"8f51d586","974":"191d547e"}[chunkId] + ".chunk.js";
};